export const hasNetworkError = (state) => !!state.global.networkError;